<template>
  <div id="lintel">
    <div>
      <p>{{ displayTitle }}</p>

      <div>
        <a @click="tryAgain" :title="$t('bill.details')">
          {{ $t('common.change') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { tryAgain } from '@/services/mixins';

export default {
  name: 'HeaderSection',
  mixins: [
    tryAgain,
  ],
  computed: {
    hasSubscription() {
      const { billTariff } = this.TRANSACTION;

      if (this.$validate.isNull(billTariff)) {
        return false;
      }

      if (!this.$validate.isObjectWithFields(billTariff, ['subscription'])) {
        return false;
      }

      if (this.$validate.isNull(billTariff.subscription)) {
        return false;
      }

      return true;
    },
    displayTitle() {
      return this.hasSubscription
        ? this.$t('common.subscribing')
        : this.$t('transaction.from.card');
    },
    ...mapState(['TRANSACTION']),
  },
};
</script>
